<template>
  <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
         _/                                                                                                                    _/
         _/      子画面定義：主担当者参照画面(STDSDC02C09)                                                                     _/
         _/                                                                                                                    _/
         _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
  <div class="frm-row" ref="STDSDC02C09" v-bind="$attrs">
    <span class="frm-label w-150px">
      <strong>主担当者</strong>
    </span>
    <span class="frm-label w-45px" v-show="this.isChangeWidth"></span>
    <div
      :tabindex="tabindex"
      @keydown.left.stop.prevent="toggleRadio"
      @keydown.right.stop.prevent="toggleRadio"
      class="frm-toggle frm-size-s"
    >
      <label>
        <input
          type="radio"
          name="toggle5"
          value="1"
          v-model="hasPersonInChargeFlag"
        />
        <span>あり</span>
      </label>
      <label>
        <input
          type="radio"
          name="toggle5"
          value="0"
          v-model="hasPersonInChargeFlag"
        />
        <span>なし</span>
      </label>
    </div>
    <input
      type="text"
      class="frm-text frm-size-xl"
      :class="{ error: isErrorPersonInCharge }"
      :value="personInChargeName"
      disabled
    />
    <button
      class="frm-btn strong"
      data-role="popup-open"
      data-target="#popup-MainUser"
      :disabled="hasPersonInChargeFlag == 0"
      @click="showSTDSDC02C09PersonInChargeModal = true"
      :tabindex="tabindex + 1"
    >
      参照
    </button>
  </div>

  <p
    class="errMsg"
    :style="{ 'margin-left': this.isChangeWidth ? '215px' : '160px' }"
    v-show="requiredErrorList.length > 0"
  >
    <ErrorMessageCase :errors="requiredErrorList"></ErrorMessageCase>
  </p>

  <BaseModal :show="showSTDSDC02C09PersonInChargeModal">
    <div class="popup" style="width: 600px">
      <div class="popup-head">主担当者の参照</div>
      <div class="popup-body blue">
        <!--
          ****  メッセージ表示領域 ****
          -->
        <p
          id="outMessageArea"
          class="errMsg title-ico ico-warning"
          v-show="errors.length > 0"
        >
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <p>主担当者を選択してください。</p>
        <!-- table -->
        <div class="frm-row">
          <div
            class="frm-search frm-size-xl"
            :class="searchKey ? 'setvalue' : ''"
          >
            <span class="frm-label">
              &nbsp;<img src="../assets/images/TDSDC/icon_search.png" />
            </span>
            <input
              type="search"
              class="frm-search-text"
              placeholder="検索キーワード"
              maxlength="255"
              v-model="searchKey"
            />
          </div>
        </div>
        <!-- table -->
        <div class="alignright">
          <p>{{ listCount }}件</p>
        </div>
        <div class="table-wrap" style="margin-top: 0px;border:none;">
          <div class="table-scroll-header">
            <table class="table-select single-select scroll">
              <colgroup>
                <col style="width: 170px" />
                <col style="width: auto" />
                <col style="width: 110px" />
              </colgroup>
              <thead>
                <tr>
                  <th class="sort hover alignleft" @click="sortData('id')">
                    ログインID
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="sort.key == 'id' && sort.isAsc ? 'on' : ''"
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="sort.key == 'id' && !sort.isAsc ? 'on' : ''"
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th class="sort hover alignleft" @click="sortData('name')">
                    利用者
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="sort.key == 'name' && sort.isAsc ? 'on' : ''"
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="sort.key == 'name' && !sort.isAsc ? 'on' : ''"
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th class="sort hover" @click="sortData('authority')">
                    権限
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'authority' && sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'authority' && !sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div
            class="table-scroll-body"
            style="height: 250px; background-color: #ffffff"
          >
            <table
              class="table-select single-select scroll"
              style="width: 100%; table-layout: fixed"
            >
              <colgroup>
                <col style="width: 170px" />
                <col style="width: auto" />
                <col style="width: 110px" />
              </colgroup>
              <tbody>
                <tr
                  v-for="person in filteredList"
                  :id="person.id"
                  :key="person.id"
                  :class="person.id == personInCharge ? 'selected' : ''"
                  @click="selectPersonInCharge(person)"
                >
                  <td>{{ person.id }}</td>
                  <td>{{ person.name }}</td>
                  <td class="aligncenter">{{ person.role }}</td>
                </tr>
              </tbody>
            </table>
            <table
              class="table-select single-select"
              v-show="filteredList.length === 0"
            >
              <tbody>
                <tr>
                  <p class="noData-area">
                    {{ noDataMessage }}
                  </p>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="popup-foot blue">
            <div class="frm-btn-row footer-btn">
              <div class="frm-item grow center">
                <button
                  class="frm-btn strong large"
                  data-role="popup-close"
                  @click="OKButtonClick"
                >
                  確定
                </button>
                <button
                  class="frm-btn large"
                  data-role="popup-close"
                  @click="cancelButtonClick"
                >
                  キャンセル
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>
<script>
import Common from "@/util/common.js";
import ErrorMessage from "@/components/ErrorMessage.vue";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import BaseModal from "@/components/Base/BaseModal.vue";
import { ACCESS_AUTH } from "@/util/enum.js";
import VueCookies from "vue-cookies";
export default {
  name: "STDSDC02C09PersonInChargeModal",
  components: { ErrorMessage, ErrorMessageCase, BaseModal },
  props: {
    modelValue: { type: String, required: true },
    personInChargeList: {
      type: Array,
      required: true,
    },
    tabindex: { type: Number, default: 0 },
    isChangeWidth: { type: Boolean, defalut: false },
  },
  data() {
    return {
      searchKey: "",
      personInCharge: "",
      requiredErrorList: [],
      isErrorPersonInCharge: false,
      errors: [],
      sort: {
        key: "", // ソートキー
        isAsc: true, // 昇順ならtrue,降順ならfalse
      },
      showSTDSDC02C09PersonInChargeModal: false, // 主担当者参照画面フラグ
      hasPersonInChargeFlag: "0", // 主担当者 ある・なし
      noDataMessage: Common.getMessage("MTCL1118", ["ユーザ"]),
    };
  },
  computed: {
    personInChargeName() {
      if (this.personInCharge) {
        const person = this.personInChargeList.find(
          (e) => e.id === this.personInCharge
        );
        if (person) {
          return person.name;
        }
      }

      return "";
    },
    filteredList() {
      let list = [...this.personInChargeList].map((e) => {
        return {
          ...e,
          role: this.accessAuthFormat(e.authority),
        };
      });
      list = list.filter((e) => {
        return (
          e?.id.includes(this.searchKey) ||
          e?.name.includes(this.searchKey) ||
          e?.role.includes(this.searchKey)
        );
      });
      list = Common.listSort(this.sort.key, this.sort.isAsc, list);

      return list;
    },
    listCount() {
      if (this.filteredList.length === this.personInChargeList.length) {
        return this.personInChargeList.length;
      } else {
        return `${this.filteredList.length}/${this.personInChargeList.length}`;
      }
    },
  },
  watch: {
    modelValue: {
      handler: function (newVal) {
        this.personInCharge = newVal;
        if (newVal) {
          this.hasPersonInChargeFlag = "1";
        }
      },
    },
    hasPersonInChargeFlag: {
      handler: function (newVal) {
        if (newVal == "0") {
          this.personInCharge = "";
        } else {
          this.personInCharge = this.modelValue;
          this.$emit("update:modelValue", this.personInCharge);
        }
      },
    },
    showSTDSDC02C09PersonInChargeModal: {
      handler: function (newVal) {
        if (newVal && !this.personInCharge) {
          const tatsuzinId = VueCookies.get("tatsuzinId");
          this.personInCharge = tatsuzinId;
          this.$nextTick(() => {
            const targetElement = document.querySelector(`#${tatsuzinId}`);
            targetElement?.scrollIntoView();
          });
        }
      },
    },
  },
  emit: ["update:modelValue", "cancelButtonClick"],
  methods: {
    validate() {
      this.requiredErrorList = [];
      this.isErrorPersonInCharge = false;
      if (this.hasPersonInChargeFlag == "1" && !this.personInCharge) {
        this.isErrorPersonInCharge = true;
        this.requiredErrorList.push(
          Common.createError(
            "MTCL1093",
            Common.getMessage("MTCL1093", ["主担当者", "主担当者"])
          )
        );
        return true;
      } else {
        return false;
      }
    },
    toggleRadio() {
      this.hasPersonInChargeFlag =
        this.hasPersonInChargeFlag == "1" ? "0" : "1";
      const focusableRadios = this.$refs.STDSDC02C09.querySelectorAll(
        'span[tabindex]:not([tabindex="-1"])'
      );
      console.info(focusableRadios);
      const el = [...focusableRadios][
        this.hasPersonInChargeFlag == "1" ? "0" : "1"
      ];
      el.focus();
    },
    // **********************************************
    // アクセス権限フォーマット
    // **********************************************
    accessAuthFormat(data) {
      // グループ
      if (data == ACCESS_AUTH.group.code) {
        return ACCESS_AUTH.group.text;
      }
      // 管理者
      else if (data == ACCESS_AUTH.admin.code) {
        return ACCESS_AUTH.admin.text;
      }
      // 管理ユーザー
      else if (data == ACCESS_AUTH.adminUser.code) {
        return ACCESS_AUTH.adminUser.text;
      }
      // 一般ユーザー
      else if (data == ACCESS_AUTH.generalUser.code) {
        return ACCESS_AUTH.generalUser.text;
      }
    },
    OKButtonClick() {
      this.errors = [];
      const person = this.filteredList.find(
        (e) => e.id === this.personInCharge
      );
      if (!person) {
        const msg = Common.createError(
          "MTCL1034",
          Common.getMessage("MTCL1034", ["主担当者"])
        );
        this.errors.push(msg);
        return;
      }
      this.showSTDSDC02C09PersonInChargeModal = false;
      this.$emit("update:modelValue", this.personInCharge);
    },
    cancelButtonClick() {
      this.personInCharge = "";
      this.showSTDSDC02C09PersonInChargeModal = false;
      this.personInCharge = this.modelValue;
      this.$emit("cancelButtonClick");
    },

    getRadioFlag() {
      return this.hasPersonInChargeFlag == "1";
    },

    selectPersonInCharge(person) {
      this.personInCharge = person.id;
    },

    sortData(key) {
      // isAsc 昇順ならtrue,降順ならfalse
      this.sort.isAsc = this.sort.key === key ? !this.sort.isAsc : true;
      this.sort.key = key;
    },
  },
};
</script>
<style scoped>
.table-scroll-header{
 border-top: 1px solid #ACACAC;
 border-left: 1px solid #ACACAC;
 border-right: 1px solid #ACACAC;
}
.table-scroll-body{
  border-bottom: 1px solid #ACACAC;
 border-left: 1px solid #ACACAC;
 border-right: 1px solid #ACACAC;
}
</style>